import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useEscapeToLeaveSettings } from "../../../components/settings/leave-settings";

/**
 * Settings is a mode of the shell, not a screen of its own: the sidebar turns into the Settings
 * index while the location is under `/settings` (see `WorkspaceSidebar`), and these routes fill
 * the panel. Esc leaves from any of them.
 */
export const Route = createFileRoute("/_authenticated/_workspace/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  useEscapeToLeaveSettings();
  return <Outlet />;
}
